import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listStaffTimeControlService } from "../service/listStaffTimeControl.service";

const LIMIT = 25;

export const useStaffTimeControlQuery = (filters) => {
  const fetchData = useFetch();
  const [staffTimeControls, setStaffTimeControls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchStaffTimeControls = async () => {
      setLoading(true);
      try {
        const response = await listStaffTimeControlService(fetchData)({
          offset: (page - 1) * LIMIT,
          limit: LIMIT,
          ...filters,
        });
        setStaffTimeControls(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error("Error fetching staff time controls:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchStaffTimeControls, 500);
    debouncedFetch();

    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page, refresh]);

  return {
    staffTimeControls,
    loading,
    page,
    onChangePage: (newPage) => setPage(newPage),
    total,
    totalPages,
    refresh: () => setRefresh((prev) => !prev),
  };
};
